import { BaseQueryFn } from "@reduxjs/toolkit/query";
import { AxiosError, AxiosRequestConfig } from "axios";
import authorizedInstance from "./authorizedInstance";

export const axiosBaseQuery =
    (
        { baseUrl }: { baseUrl: string } = { baseUrl: '' }
    ): BaseQueryFn<
        {
            url: string;
            method: AxiosRequestConfig['method'];
            data?: AxiosRequestConfig['data'];
            params?: AxiosRequestConfig['params'];
            signal?: AbortSignal;
        },
        unknown,
        unknown
    > =>
        async ({ url, method, data, params, signal }) => {
            try {
                const result = await authorizedInstance({
                    url: baseUrl + url,
                    method,
                    data,
                    params,
                    signal,
                });
                return { data: result.data };
            } catch (axiosError) {
                const err = axiosError as AxiosError;
                return {
                    error: {
                        status: err.response?.status || 500,
                        data: err.response?.data || err.message,
                    },
                };
            }
        };
